<template>
  <div class="legal">
    <BaseBtn
      v-if="configAccess.dealer_companies.main === 2 && (!addNew || !isMobile)"
      @btnClick="toggleAddNew"
      class="legal__add"
      :text="'Добавить плательщика'" />
    <div :class="[
      {'open': addNew},
      'legal__wrap'
    ]">
      <div class="legal__title">Плательщики</div>
      <List
        :info="info"
        :list="companies"
        @toggleAddNew="toggleAddNew" />
    </div>
    <New
      v-if="addNew"
      :info="info"
      :class="{'open': addNew}"
      @toggleAddNew="toggleAddNew"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AccountProfile",

  components: {
    New: () => import('./components/New'),
    List: () => import('./components/List'),
    BaseBtn: () => import('@/components/base/BaseBtn'),
  },

  metaInfo () {
    return {
      title: `Плательщики - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    addNew: false,
    info: {
      data: null,
      index: null,
    },
  }),

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
      companies: state => state.user.companies,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    toggleAddNew() {
      this.addNew = !this.addNew;
    },
  }
}
</script>

<style scoped lang="scss">
.legal {
  padding-bottom: 30px;

  @media(max-width: $desktop) {
    min-height: calc(100% - 45px);
  }

  &__wrap {
    @media(max-width: $desktop) {
      display: block;

      &.open {
        display: none;
      }
    }
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__add {
    width: 100%;
    max-width: 364px;
    margin-top: 25px;
    margin-right: 35px;
  }
}
</style>
